import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Component({
    selector: 'app-simple-error-list',
    templateUrl: './simple-error-list.component.html',
    styleUrls: ['./simple-error-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleErrorListComponent implements OnInit {

  @Input() control!: AbstractControl;

  constructor() { }

  ngOnInit(): void {
  }

  getErrorMessage(errorKey: string, errorValue: any): string {
    switch (errorKey) {
      case 'required':
        return 'This field is required';
      case 'minlength':
        return `Minimum length is ${errorValue.requiredLength} characters`;
      case 'maxlength':
        return `Maximum length is ${errorValue.requiredLength} characters`;
      case 'invalidZip':
        return 'The zip code must be 5 or 9 characters';
      case 'invalidAin':
        return 'The AIN provided is invalid';
      case 'noCountyEmail':
        return 'LA County emails are forbidden';
      case 'noFutureDates':
        return 'The date cannot be in the future';
      case 'invalidSsn':
        return 'The SSN provided is invalid';
      case 'regexValidator':
        return 'The data was not in the expect format';
      case 'signixEmailTooLong':
        return 'The input email cannot exceed 50 characters';
      case 'requiredCheckbox':
        return 'You must acknowledge this statement to continue';
      case 'min':
        return `Minimum value is ${errorValue.min}`;
      case 'max':
        return `Maximum value is ${errorValue.max}`;
      case 'email':
        return 'The provided email is invalid';
      default:
        return `No error found for ${errorKey}`;
    }
  }

}
